import React, { useEffect, useState, useRef } from 'react';
import { BrainIcon, ImageIcon, SendIcon, MessageSquareIcon, ReplyIcon } from 'lucide-react';
interface Post {
  id: number;
  author: {
    name: string;
    avatar: string;
    location: string;
  };
  content: string;
  timestamp: string;
  likes: number;
  comments: Comment[];
  hasAiTag: boolean;
}
interface Comment {
  id: number;
  author: {
    name: string;
    avatar: string;
    isAi?: boolean;
  };
  content: string;
  timestamp: string;
  replies?: Reply[];
}
interface Reply {
  id: number;
  author: {
    name: string;
    avatar: string;
    isAi?: boolean;
  };
  content: string;
  timestamp: string;
}
// Group-specific posts
const GROUP_POSTS: Record<string, Post[]> = {
  '1': [{
    id: 1,
    author: {
      name: 'Laura Bianchi',
      avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      location: 'Milano'
    },
    content: 'Ho ridotto lo spreco in frigo con 3 regole semplici: contenitori trasparenti, "prima scade davanti", e lista settimanale. Voi che metodo usate?',
    timestamp: '2 ore fa',
    likes: 18,
    hasAiTag: false,
    comments: [{
      id: 1,
      author: {
        name: 'Marco Rossi',
        avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
      },
      content: "Io uso anche un'etichetta con data di apertura, aiuta tantissimo.",
      timestamp: '1 ora fa'
    }, {
      id: 2,
      author: {
        name: 'Greenback AI',
        avatar: 'https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png',
        isAi: true
      },
      content: 'Suggerimento: prova la regola "3 pasti" (pianifica 3 pasti fissi e ruota gli ingredienti più deperibili).',
      timestamp: '1 ora fa'
    }]
  }, {
    id: 2,
    author: {
      name: 'Giulia Neri',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      location: 'Roma'
    },
    content: 'Idee per sostituire pellicola e carta forno? Sto provando coperchi in silicone e tappetini riutilizzabili.',
    timestamp: '6 ore fa',
    likes: 11,
    hasAiTag: false,
    comments: [{
      id: 1,
      author: {
        name: 'Sara Conti',
        avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
      },
      content: 'Tappetino in silicone + contenitori vetro, mai più tornata indietro.',
      timestamp: '5 ore fa'
    }]
  }, {
    id: 3,
    author: {
      name: 'Marco Rossi',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      location: 'Torino'
    },
    content: 'Ho iniziato a comprare sfuso: legumi, cereali e detersivi. Quali negozi refill consigliate (per città)?',
    timestamp: '1 giorno fa',
    likes: 22,
    hasAiTag: false,
    comments: [{
      id: 1,
      author: {
        name: 'Greenback AI',
        avatar: 'https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png',
        isAi: true
      },
      content: 'Per facilitare: scrivi città + quartiere e aggiungi che categoria cerchi (food, detergenza, cosmesi).',
      timestamp: '1 giorno fa'
    }]
  }],
  '2': [{
    id: 1,
    author: {
      name: 'Alessandro Verdi',
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      location: 'Torino'
    },
    content: 'Sto ottimizzando il tragitto casa-lavoro: meno semafori, più ciclabili. Condividete i vostri percorsi "sicuri"?',
    timestamp: '3 ore fa',
    likes: 14,
    hasAiTag: false,
    comments: [{
      id: 1,
      author: {
        name: 'Chiara Riva',
        avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
      },
      content: 'Io uso una regola: preferisco strade secondarie anche se allungo di 5 minuti.',
      timestamp: '2 ore fa'
    }, {
      id: 2,
      author: {
        name: 'Greenback AI',
        avatar: 'https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png',
        isAi: true
      },
      content: 'Tip: prova a valutare il percorso su 3 criteri (sicurezza, continuità, tempo) e salva 2 alternative per meteo diverso.',
      timestamp: '2 ore fa'
    }]
  }, {
    id: 2,
    author: {
      name: 'Chiara Riva',
      avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      location: 'Milano'
    },
    content: 'Consigli per antifurto e parcheggio? Mi hanno già rubato una luce…',
    timestamp: '7 ore fa',
    likes: 9,
    hasAiTag: false,
    comments: [{
      id: 1,
      author: {
        name: 'Alessandro Verdi',
        avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
      },
      content: 'U-lock + cavo, e sempre telaio + ruota. Le luci meglio sganciarle.',
      timestamp: '6 ore fa'
    }]
  }, {
    id: 3,
    author: {
      name: 'Edoardo G.',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      location: 'Bologna'
    },
    content: 'Ho provato intermodalità treno + bici pieghevole: game changer. Qualcuno ha modelli consigliati?',
    timestamp: '1 giorno fa',
    likes: 16,
    hasAiTag: false,
    comments: [{
      id: 1,
      author: {
        name: 'Greenback AI',
        avatar: 'https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png',
        isAi: true
      },
      content: 'Prima di scegliere: peso (<=12kg), tempo di chiusura, e disponibilità assistenza/ricambi in città.',
      timestamp: '1 giorno fa'
    }]
  }],
  '3': [{
    id: 1,
    author: {
      name: 'Sara Conti',
      avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      location: 'Roma'
    },
    content: 'Ricette anti-spreco: con gambi di broccoli ho fatto pesto e polpette. Avete idee simili?',
    timestamp: '1 ora fa',
    likes: 20,
    hasAiTag: false,
    comments: [{
      id: 1,
      author: {
        name: 'Luca Ferri',
        avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
      },
      content: 'Io uso le foglie di cavolfiore per una zuppa, vengono top.',
      timestamp: '30 min fa'
    }, {
      id: 2,
      author: {
        name: 'Greenback AI',
        avatar: 'https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png',
        isAi: true
      },
      content: 'Idea: "base" anti-spreco in 3 passi (saltare + frullare + legare con legumi o pane raffermo).',
      timestamp: '20 min fa'
    }]
  }, {
    id: 2,
    author: {
      name: 'Luca Ferri',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      location: 'Milano'
    },
    content: 'Sto provando a comprare più stagionale: quali verdure consigliate questa settimana?',
    timestamp: '5 ore fa',
    likes: 13,
    hasAiTag: false,
    comments: [{
      id: 1,
      author: {
        name: 'Greenback AI',
        avatar: 'https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png',
        isAi: true
      },
      content: 'Per scegliere veloce: 3 verdure + 2 legumi + 1 cereale. Crea 2 piatti "rotazione" per ridurre spreco.',
      timestamp: '4 ore fa'
    }]
  }, {
    id: 3,
    author: {
      name: 'Elena P.',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      location: 'Torino'
    },
    content: 'Etichette: come capite se un prodotto è davvero "green"? Mi perdo tra claim e packaging.',
    timestamp: '1 giorno fa',
    likes: 17,
    hasAiTag: false,
    comments: [{
      id: 1,
      author: {
        name: 'Sara Conti',
        avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
      },
      content: 'Io guardo ingredienti, provenienza e se ci sono certificazioni chiare. E diffido dei claim vaghi.',
      timestamp: '1 giorno fa'
    }]
  }]
};
const GroupFeed: React.FC<{
  groupId?: string;
}> = ({
  groupId
}) => {
  const [posts, setPosts] = useState<Post[]>(GROUP_POSTS[groupId || '1'] || GROUP_POSTS['1']);
  const [newPostContent, setNewPostContent] = useState('');
  const [showMentionDropdown, setShowMentionDropdown] = useState(false);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  // Update posts when groupId changes
  useEffect(() => {
    setPosts(GROUP_POSTS[groupId || '1'] || GROUP_POSTS['1']);
  }, [groupId]);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowMentionDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const text = e.target.value;
    setNewPostContent(text);
    const lastChar = text.slice(-1);
    if (lastChar === '@') {
      setShowMentionDropdown(true);
    } else if (text.indexOf('@') === -1) {
      setShowMentionDropdown(false);
    }
  };
  const insertMention = () => {
    const cursorPosition = textareaRef.current?.selectionStart || 0;
    const textBeforeCursor = newPostContent.substring(0, cursorPosition);
    const textAfterCursor = newPostContent.substring(cursorPosition);
    const lastAtIndex = textBeforeCursor.lastIndexOf('@');
    if (lastAtIndex !== -1) {
      const newText = textBeforeCursor.substring(0, lastAtIndex) + '@Greenback AI ' + textAfterCursor;
      setNewPostContent(newText);
    }
    setShowMentionDropdown(false);
    textareaRef.current?.focus();
  };
  const handleCreatePost = () => {
    if (!newPostContent.trim()) return;
    const hasAiTag = newPostContent.toLowerCase().includes('@greenback');
    const newPost: Post = {
      id: posts.length + 1,
      author: {
        name: 'Alex Rossi',
        avatar: 'https://cdn.magicpatterns.com/uploads/wAuXNp8Njv5DkmF4gEUeC7/jonathan-cooper-ViyA5myhBVw-unsplash.jpg',
        location: 'Milano'
      },
      content: newPostContent,
      timestamp: 'Ora',
      likes: 0,
      comments: [],
      hasAiTag
    };
    setPosts([newPost, ...posts]);
    setNewPostContent('');
    if (hasAiTag) {
      setTimeout(() => {
        setPosts(prevPosts => {
          const updatedPosts = [...prevPosts];
          const postIndex = updatedPosts.findIndex(p => p.id === newPost.id);
          if (postIndex !== -1) {
            updatedPosts[postIndex] = {
              ...updatedPosts[postIndex],
              comments: [...updatedPosts[postIndex].comments, {
                id: Date.now(),
                author: {
                  name: 'Greenback AI',
                  avatar: 'https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png',
                  isAi: true
                },
                content: "Grazie per avermi taggato! Ho analizzato il tuo post e sono qui per aiutarti. Possiamo approfondire l'argomento insieme?",
                timestamp: 'Ora',
                replies: []
              }]
            };
          }
          return updatedPosts;
        });
      }, 500);
    }
  };
  return <div className="space-y-6" data-id="element-1715">
      {/* Create Post */}
      <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm" data-id="element-1716">
        <div className="flex items-start gap-4" data-id="element-1717">
          <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0" data-id="element-1718">
            <img src="https://cdn.magicpatterns.com/uploads/wAuXNp8Njv5DkmF4gEUeC7/jonathan-cooper-ViyA5myhBVw-unsplash.jpg" alt="User Avatar" className="w-full h-full object-cover" data-id="element-1719" />
          </div>
          <div className="flex-1 relative" data-id="element-1720">
            <textarea ref={textareaRef} value={newPostContent} onChange={handleTextChange} placeholder="Condividi qualcosa con il gruppo..." className="w-full min-h-[100px] p-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 resize-none font-normal text-sm" data-id="element-1721" />
            {showMentionDropdown && <div ref={dropdownRef} className="absolute z-10 bg-white rounded-lg shadow-xl border border-gray-200 w-64 mt-1" data-id="element-1722">
                <div className="p-3 flex items-center gap-3 hover:bg-gray-50 cursor-pointer transition-colors" onClick={insertMention} data-id="element-1723">
                  <div className="w-8 h-8 rounded-full overflow-hidden bg-green-100 flex items-center justify-center" data-id="element-1724">
                    <img src="https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png" alt="Greenback AI" className="w-6 h-6 object-contain" data-id="element-1725" />
                  </div>
                  <div data-id="element-1726">
                    <div className="font-medium text-gray-800 text-sm" data-id="element-1727">
                      Greenback AI
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-1728">Assistente AI</div>
                  </div>
                </div>
              </div>}
            <div className="flex justify-between items-center mt-3" data-id="element-1729">
              <div className="flex items-center gap-2 text-gray-500" data-id="element-1730">
                <button className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-1731">
                  <ImageIcon size={18} strokeWidth={1.5} data-id="element-1732" />
                </button>
                <button className="p-2 hover:bg-gray-100 rounded-full transition-colors" onClick={() => setNewPostContent(prev => prev + ' @Greenback AI ')} title="Menziona Greenback AI" data-id="element-1733">
                  <BrainIcon size={18} strokeWidth={1.5} data-id="element-1734" />
                </button>
              </div>
              <button onClick={handleCreatePost} className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors flex items-center gap-2 text-sm font-medium" data-id="element-1735">
                <SendIcon size={16} strokeWidth={1.5} data-id="element-1736" />
                Pubblica
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Posts List */}
      <div className="space-y-4" data-id="element-1737">
        {posts.map(post => <PostCard key={post.id} post={post} onUpdatePost={updatedPost => {
        setPosts(posts.map(p => p.id === updatedPost.id ? updatedPost : p));
      }} data-id="element-1738" />)}
      </div>
    </div>;
};
const PostCard: React.FC<{
  post: Post;
  onUpdatePost: (post: Post) => void;
}> = ({
  post,
  onUpdatePost
}) => {
  return <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm hover:shadow-md transition-shadow" data-id="element-1739">
      {/* Author Info */}
      <div className="flex items-center gap-3 mb-4" data-id="element-1740">
        <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0" data-id="element-1741">
          <img src={post.author.avatar} alt={post.author.name} className="w-full h-full object-cover" data-id="element-1742" />
        </div>
        <div data-id="element-1743">
          <h3 className="font-medium text-gray-800" data-id="element-1744">{post.author.name}</h3>
          <p className="text-sm text-gray-500 font-normal" data-id="element-1745">
            {post.author.location} • {post.timestamp}
          </p>
        </div>
      </div>
      {/* Post Content */}
      <p className="text-gray-700 mb-4 whitespace-pre-wrap font-normal leading-relaxed" data-id="element-1746">
        {post.content}
      </p>
      {/* Actions */}
      <div className="flex items-center gap-4 text-gray-500 text-sm border-t border-gray-100 pt-3 font-normal" data-id="element-1747">
        <button className="flex items-center gap-1.5 hover:text-green-600 transition-colors" data-id="element-1748">
          <span data-id="element-1749">👍</span> {post.likes}
        </button>
        <button className="flex items-center gap-1.5 hover:text-green-600 transition-colors" data-id="element-1750">
          <MessageSquareIcon size={16} strokeWidth={1.5} data-id="element-1751" />{' '}
          {post.comments.length}
        </button>
      </div>
      {/* Comments */}
      {post.comments.length > 0 && <div className="mt-4 space-y-3" data-id="element-1752">
          {post.comments.map(comment => <CommentCard key={comment.id} comment={comment} postId={post.id} onAddReply={(commentId, newReply) => {
        const updatedComments = post.comments.map(c => {
          if (c.id === commentId) {
            return {
              ...c,
              replies: [...(c.replies || []), newReply]
            };
          }
          return c;
        });
        onUpdatePost({
          ...post,
          comments: updatedComments
        });
      }} data-id="element-1753" />)}
        </div>}
    </div>;
};
const CommentCard: React.FC<{
  comment: Comment;
  postId: number;
  onAddReply: (commentId: number, reply: Reply) => void;
}> = ({
  comment,
  postId,
  onAddReply
}) => {
  const [isReplying, setIsReplying] = useState(false);
  const [replyContent, setReplyContent] = useState('');
  const handleSubmitReply = () => {
    if (!replyContent.trim()) return;
    const newReply: Reply = {
      id: Date.now(),
      author: {
        name: 'Alex Rossi',
        avatar: 'https://cdn.magicpatterns.com/uploads/wAuXNp8Njv5DkmF4gEUeC7/jonathan-cooper-ViyA5myhBVw-unsplash.jpg'
      },
      content: replyContent,
      timestamp: 'Ora'
    };
    onAddReply(comment.id, newReply);
    setReplyContent('');
    setIsReplying(false);
  };
  return <div className="space-y-3" data-id="element-1754">
      <div className="flex items-start gap-3 bg-gray-50 rounded-lg p-3" data-id="element-1755">
        <div className={`w-8 h-8 rounded-full overflow-hidden flex-shrink-0 ${comment.author.isAi ? 'bg-green-100 flex items-center justify-center' : ''}`} data-id="element-1756">
          {comment.author.isAi ? <img src={comment.author.avatar} alt={comment.author.name} className="w-5 h-5 object-contain" data-id="element-1757" /> : <img src={comment.author.avatar} alt={comment.author.name} className="w-full h-full object-cover" data-id="element-1758" />}
        </div>
        <div className="flex-1" data-id="element-1759">
          <div className="flex items-center gap-2 mb-1" data-id="element-1760">
            <h4 className="font-medium text-gray-800 text-sm" data-id="element-1761">
              {comment.author.name}
            </h4>
            {comment.author.isAi && <span className="bg-green-100 text-green-700 text-xs px-2 py-0.5 rounded-full font-medium" data-id="element-1762">
                AI
              </span>}
            <span className="text-xs text-gray-500 font-normal" data-id="element-1763">
              {comment.timestamp}
            </span>
          </div>
          <p className="text-gray-700 text-sm font-normal leading-relaxed whitespace-pre-wrap" data-id="element-1764">
            {comment.content}
          </p>
          <div className="mt-2" data-id="element-1765">
            <button onClick={() => setIsReplying(!isReplying)} className="text-xs text-gray-500 hover:text-gray-700 flex items-center gap-1 font-normal" data-id="element-1766">
              <ReplyIcon size={14} strokeWidth={1.5} data-id="element-1767" />
              Rispondi
            </button>
          </div>
        </div>
      </div>
      {/* Replies */}
      {comment.replies && comment.replies.length > 0 && <div className="ml-8 space-y-3" data-id="element-1768">
          {comment.replies.map(reply => <div key={reply.id} className="flex items-start gap-3 bg-gray-50 rounded-lg p-3" data-id="element-1769">
              <div className={`w-8 h-8 rounded-full overflow-hidden flex-shrink-0 ${reply.author.isAi ? 'bg-green-100 flex items-center justify-center' : ''}`} data-id="element-1770">
                {reply.author.isAi ? <img src={reply.author.avatar} alt={reply.author.name} className="w-5 h-5 object-contain" data-id="element-1771" /> : <img src={reply.author.avatar} alt={reply.author.name} className="w-full h-full object-cover" data-id="element-1772" />}
              </div>
              <div data-id="element-1773">
                <div className="flex items-center gap-2 mb-1" data-id="element-1774">
                  <h4 className="font-medium text-gray-800 text-sm" data-id="element-1775">
                    {reply.author.name}
                  </h4>
                  {reply.author.isAi && <span className="bg-green-100 text-green-700 text-xs px-2 py-0.5 rounded-full font-medium" data-id="element-1776">
                      AI
                    </span>}
                  <span className="text-xs text-gray-500 font-normal" data-id="element-1777">
                    {reply.timestamp}
                  </span>
                </div>
                <p className="text-gray-700 text-sm font-normal leading-relaxed whitespace-pre-wrap" data-id="element-1778">
                  {reply.content}
                </p>
              </div>
            </div>)}
        </div>}
      {/* Reply Form */}
      {isReplying && <div className="ml-8 bg-white rounded-lg border border-gray-200 p-3" data-id="element-1779">
          <textarea value={replyContent} onChange={e => setReplyContent(e.target.value)} placeholder="Scrivi una risposta..." className="w-full min-h-[80px] p-2 rounded-lg border border-gray-200 focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 resize-none text-sm font-normal" data-id="element-1780" />
          <div className="flex justify-end gap-2 mt-2" data-id="element-1781">
            <button onClick={() => setIsReplying(false)} className="px-3 py-1.5 text-sm text-gray-600 hover:text-gray-800 font-normal" data-id="element-1782">
              Annulla
            </button>
            <button onClick={handleSubmitReply} className="bg-green-600 text-white px-3 py-1.5 rounded-lg hover:bg-green-700 transition-colors text-sm flex items-center gap-1 font-medium" data-id="element-1783">
              <SendIcon size={14} strokeWidth={1.5} data-id="element-1784" />
              Invia
            </button>
          </div>
        </div>}
    </div>;
};
export default GroupFeed;